import React from "react";
import { dateFormatInverse, hourFormat } from "functions/functions";
import "./headerCardEvent.sass";

export default function HeaderCardEvent({ nameEvent, statusEvent, classEvent, urlEvent, dateUTC }) {

  return (
    urlEvent ? (
      <a className={"header-card-evento " + classEvent} href={urlEvent} target="_top">
        {renderContent()}
      </a>
    ) : (
      <div className={"header-card-evento " + classEvent}>
        {renderContent()}
      </div>
    )
  );

  function renderContent() {
    return (
      <>
        <div className="evento-liga">
          <p className="name-liga">{nameEvent}</p>
        </div>

        <div className="evento-period">
          {classEvent === "clarosports-finished-game" || classEvent === "clarosports-error-game"
            ? <p className="name-period">{String(statusEvent).toUpperCase()}</p>
            : classEvent === "clarosports-in-progress-game"
              ? <>
                <div className="container-live"><p className="name-period">EN VIVO</p></div>
                <p className="period-live">{statusEvent}</p>
              </>
              : classEvent === "clarosports-next-game"
              && <p className="name-period">{dateFormatInverse(dateUTC)} {hourFormat(dateUTC)}hrs</p>
          }
        </div>
      </>
    );
  }
}
